module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"create_user_label":"Neue Person hinzufügen","cancel":"Abbrechen","save":"Speichern"},"en":{"create_user_label":"Add new person","cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
